module.exports = __webpack_public_path__ + "static/img/close_lottery.3d1c73b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/close_lottery.png
// module id = +31Q
// module chunks = 6